/*****components***/
import React, { Component } from "react";
import {
  Table as AntTable,
  Tabs,
  Tag,
  Drawer,
  Checkbox,
  Select,
  DatePicker,
  Input,
  Button,
  Empty,
  Tooltip,
} from "antd";
import moment from "moment";
import { ExcelJS, addSummarySheet, addDataSheet, downloadWorkbook } from "./excelExportUtils";
import { API_CONFIG } from "../../Config/config-env.js";
import axios from "axios";

/*custom components*/
import PageLoading from "../../Components/PageLoading/index.js";

/*functions*/
import {
  applyExternalDarkMode,
  buildStoreOptions,
  getCasaIdeasStores,
  getParentOfficeCode,
  getStoreNameByOfficeCode,
  normalizeOfficeCode,
  searchHandler,
  findObjName,
  callexternalApi,
  find,
} from "../../Config/functions.js";

const { TabPane } = Tabs;
const { Option } = Select;

// El selector de fecha conserva la hora de carga de la pagina al elegir un dia, lo que
// cortaba el rango del export. Se toma siempre el dia completo en hora Bolivia (UTC-4):
// 00:00:00 -> 04:00Z y 23:59:59 -> 03:59:59Z del dia siguiente. El backend resta 4h a lo
// que recibe, asi que llega 00:00:00 y 23:59:59 tal cual contra la hora de la BD.
const BOLIVIA_OFFSET_H = 4;
const boliviaDayStart = (d) => {
  const x = new Date(d);
  return new Date(Date.UTC(x.getFullYear(), x.getMonth(), x.getDate(), BOLIVIA_OFFSET_H, 0, 0, 0));
};
const boliviaDayEnd = (d) => {
  const x = new Date(d);
  return new Date(Date.UTC(x.getFullYear(), x.getMonth(), x.getDate() + 1, BOLIVIA_OFFSET_H - 1, 59, 59, 999));
};

var f = new Date();
var now = new Date();
var fromDate = new Date(now.getFullYear(), now.getMonth() - 1, 1);

var mes =
  f.getUTCMonth() + 1 < 10 ? "0" + (f.getUTCMonth() + 1) : f.getUTCMonth() + 1;
var dia = f.getUTCDate() < 10 ? "0" + f.getUTCDate() : f.getUTCDate();
var date_label = f.getUTCFullYear() + "." + mes + "." + dia;

const expandComboSkuRows = (row) => {
  if (typeof row.SKU !== "string" || row.SKU.indexOf(",") < 0) {
    return [row];
  }

  const skus = row.SKU
    .split(",")
    .map((sku) => sku.trim())
    .filter((sku) => sku !== "");

  if (skus.length <= 1) {
    return [row];
  }

  return skus.map((sku) => ({
    ...row,
    SKU: sku,
  }));
};

// Etiquetas de los estados del traspaso pickup (ordenes.estado_pickup)
const PICKUP_STATE_LABELS = {
  procesando: "En espera de traspaso",
  recepcion: "Recepcionando traspaso",
  recepcionado: "Picking productos recibidos",
  finalizado: "Estado Finalizado",
};

const mapPickupState = (value) => {
  // valores heredados de xflow a veces todavía traen el sufijo "todo"
  // (ej. "procesandotodo") de la convención vieja de pickup 100%.
  const clean = String(value || "").trim().toLowerCase().replace(/todo$/, "");
  return PICKUP_STATE_LABELS[clean] || value;
};

const parseSkusField = (value) => {
  if (Array.isArray(value)) return value;
  try {
    return JSON.parse(value) || [];
  } catch (e) {
    return [];
  }
};

const formatMoney = (value) =>
  Number(value || 0).toLocaleString("es-BO", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });

// Colores de estado al estilo de paneles ecommerce
const STATUS_COLORS = [
  { match: /cancelado/i, color: "red" },
  { match: /finalizado|entregado/i, color: "green" },
  { match: /pendiente de pago|pendiente pago/i, color: "volcano" },
  { match: /pendiente/i, color: "gold" },
  { match: /procesando traspaso|espera de traspaso|recepcionando/i, color: "orange" },
  { match: /picking/i, color: "orange" },
  { match: /procesando/i, color: "blue" },
  { match: /preparando/i, color: "geekblue" },
  { match: /listo para/i, color: "cyan" },
  { match: /programada/i, color: "purple" },
  { match: /espera/i, color: "orange" },
];

const statusColor = (status) => {
  const s = String(status || "");
  const found = STATUS_COLORS.find((c) => c.match.test(s));
  return found ? found.color : "default";
};

// Columnas con formato de moneda
const MONEY_COLS = [
  "SUBTOTAL_ORDER",
  "SHIPPINGCOST",
  "DISCOUNT",
  "TOTAL_ORDER",
  "SKU_REGULAR_PRICE",
  "SKU_PRICE",
  "SKU_TOTAL",
];

const PAGE_CSS = `
.xrep2 { font-size: 13px; }
.xrep2 .xrep2-header { display:flex; flex-wrap:wrap; justify-content:space-between; align-items:center; gap:12px; margin-bottom:14px; }
.xrep2 .xrep2-title h2 { margin:0; font-weight:700; letter-spacing:-0.3px; }
.xrep2 .xrep2-title small { color:#8c8c8c; }
.xrep2 .xrep2-actions { display:flex; gap:8px; align-items:center; }
.xrep2 .xrep2-panel { background:#fff; border:1px solid #ececec; border-radius:10px; padding:14px 16px; margin-bottom:14px; box-shadow:0 1px 3px rgba(15,23,42,.05); }
.xrep2 .xrep2-filters-grid { display:grid; grid-template-columns:repeat(auto-fit, minmax(170px, 1fr)); gap:10px 12px; }
.xrep2 .xrep2-field label { display:block; font-size:11px; font-weight:600; text-transform:uppercase; letter-spacing:.4px; color:#8c8c8c; margin-bottom:3px; }
.xrep2 .xrep2-filters-footer { display:flex; justify-content:space-between; align-items:center; margin-top:12px; flex-wrap:wrap; gap:8px; }
.xrep2 .xrep2-kpis { display:grid; grid-template-columns:repeat(auto-fit, minmax(170px, 1fr)); gap:12px; margin-bottom:14px; }
.xrep2 .xrep2-kpi { background:#fff; border:1px solid #ececec; border-radius:10px; padding:12px 14px; display:flex; align-items:center; gap:12px; box-shadow:0 1px 3px rgba(15,23,42,.05); }
.xrep2 .xrep2-kpi-icon { width:40px; height:40px; border-radius:10px; display:flex; align-items:center; justify-content:center; font-size:17px; color:#fff; flex-shrink:0; }
.xrep2 .xrep2-kpi-label { font-size:11px; text-transform:uppercase; letter-spacing:.4px; color:#8c8c8c; margin:0; }
.xrep2 .xrep2-kpi-value { font-size:19px; font-weight:700; margin:0; line-height:1.2; }
.xrep2 .xrep2-tables { background:#fff; border:1px solid #ececec; border-radius:10px; padding:6px 16px 16px; box-shadow:0 1px 3px rgba(15,23,42,.05); }
.xrep2 .ant-table-thead > tr > th { background:#fafafa; font-size:11px; text-transform:uppercase; letter-spacing:.3px; color:#595959; white-space:nowrap; }
.xrep2 .ant-table-tbody > tr > td { font-size:12.5px; }
.xrep2 .ant-tabs-tab { font-weight:600; }
.xrep2 .xrep2-money { text-align:right; font-variant-numeric:tabular-nums; display:block; }
.xrep2 .xrep2-orderid { font-weight:700; font-variant-numeric:tabular-nums; }
.xrep2 .xrep2-mono { font-family:SFMono-Regular,Consolas,monospace; font-size:12px; }
.xrep2 .xrep2-elapsed { color:#8c8c8c; font-size:12px; }
.xflow-external-dark .xrep2 .xrep2-panel,
.xflow-external-dark .xrep2 .xrep2-kpi,
.xflow-external-dark .xrep2 .xrep2-tables { background:#1f2430; border-color:#2c3242; }
.xflow-external-dark .xrep2 .xrep2-kpi-value { color:#e8eaf0; }
.xflow-external-dark .xrep2 .ant-table-thead > tr > th { background:#252b39; color:#aab; }
.xflow-external-dark .xrep2 .xrep2-field label { color:#8592ad; }

/* ---- Dark mode: inputs, select, datepicker (trigger) ---- */
.xflow-external-dark .xrep2 .ant-picker,
.xflow-external-dark .xrep2 .ant-select:not(.ant-select-disabled) .ant-select-selector,
.xflow-external-dark .xrep2 .ant-input,
.xflow-external-dark .xrep2 .ant-input-affix-wrapper {
  background:#0f172a; border-color:#334155; color:#f8fafc;
}
.xflow-external-dark .xrep2 .ant-picker-input > input,
.xflow-external-dark .xrep2 .ant-select-selection-item,
.xflow-external-dark .xrep2 .ant-select-selection-search-input,
.xflow-external-dark .xrep2 .ant-input {
  color:#f8fafc;
}
.xflow-external-dark .xrep2 .ant-select-selection-placeholder,
.xflow-external-dark .xrep2 .ant-picker-input > input::placeholder,
.xflow-external-dark .xrep2 .ant-input::placeholder {
  color:#64748b;
}
.xflow-external-dark .xrep2 .ant-picker-suffix,
.xflow-external-dark .xrep2 .ant-picker-clear,
.xflow-external-dark .xrep2 .ant-select-arrow,
.xflow-external-dark .xrep2 .ant-select-clear,
.xflow-external-dark .xrep2 .ant-input-clear-icon {
  color:#64748b; background:transparent;
}
.xflow-external-dark .xrep2 .ant-picker:hover,
.xflow-external-dark .xrep2 .ant-select:hover .ant-select-selector,
.xflow-external-dark .xrep2 .ant-input:hover {
  border-color:#475569;
}
.xflow-external-dark .xrep2 .ant-picker-focused,
.xflow-external-dark .xrep2 .ant-select-focused .ant-select-selector,
.xflow-external-dark .xrep2 .ant-input:focus,
.xflow-external-dark .xrep2 .ant-input-focused {
  border-color:#1890ff !important; box-shadow:0 0 0 2px rgba(24,144,255,.2) !important;
}
.xflow-external-dark .xrep2 .ant-select-multiple .ant-select-selection-item {
  background:#1e293b; border-color:#334155; color:#e2e8f0;
}
.xflow-external-dark .xrep2 .ant-select-multiple .ant-select-selection-item-remove {
  color:#94a3b8;
}

/* ---- Dark mode: buttons ---- */
.xflow-external-dark .xrep2 .ant-btn:not(.ant-btn-primary):not(.ant-btn-link) {
  background:#182235; border-color:#334155; color:#e2e8f0;
}
.xflow-external-dark .xrep2 .ant-btn:not(.ant-btn-primary):not(.ant-btn-link):hover,
.xflow-external-dark .xrep2 .ant-btn:not(.ant-btn-primary):not(.ant-btn-link):focus {
  background:#1e293b; border-color:#475569; color:#fff;
}
.xflow-external-dark .xrep2 .ant-btn-link { color:#60a5fa; }
.xflow-external-dark .xrep2 .ant-btn-link:hover { color:#93c5fd; }
.xflow-external-dark .xrep2 .ant-btn[disabled],
.xflow-external-dark .xrep2 .ant-btn[disabled]:hover {
  background:#141a26; border-color:#2c3242; color:#4b5568;
}

/* ---- Dark mode: tabs ---- */
.xflow-external-dark .xrep2 .ant-tabs-tab { color:#8592ad; }
.xflow-external-dark .xrep2 .ant-tabs-tab:hover { color:#e2e8f0; }
.xflow-external-dark .xrep2 .ant-tabs-tab.ant-tabs-tab-active .ant-tabs-tab-btn { color:#60a5fa; }
.xflow-external-dark .xrep2 .ant-tabs-ink-bar { background:#1890ff; }
.xflow-external-dark .xrep2 .ant-tabs-nav::before { border-color:#2c3242; }

/* ---- Dark mode: empty state ---- */
.xflow-external-dark .xrep2 .ant-empty-description { color:#8592ad; }

/* ---- Dark mode: select/datepicker popups (rendered via portal, outside .xrep2) ---- */
.xflow-external-dark .xrep2-popup.ant-select-dropdown {
  background:#182235; box-shadow:0 4px 18px rgba(0,0,0,.45);
}
.xflow-external-dark .xrep2-popup .ant-select-item {
  color:#e2e8f0;
}
.xflow-external-dark .xrep2-popup .ant-select-item-option-active:not(.ant-select-item-option-disabled) {
  background:#1e293b;
}
.xflow-external-dark .xrep2-popup .ant-select-item-option-selected:not(.ant-select-item-option-disabled) {
  background:#0c2a3d; color:#7dd3fc;
}
.xflow-external-dark .xrep2-popup .ant-select-item-empty {
  color:#64748b;
}
.xflow-external-dark .xrep2-popup.ant-picker-dropdown .ant-picker-panel-container {
  background:#182235; box-shadow:0 4px 18px rgba(0,0,0,.45);
}
.xflow-external-dark .xrep2-popup .ant-picker-panel {
  background:#182235; border-color:#334155;
}
.xflow-external-dark .xrep2-popup .ant-picker-header {
  color:#e2e8f0; border-color:#334155;
}
.xflow-external-dark .xrep2-popup .ant-picker-header button {
  color:#94a3b8;
}
.xflow-external-dark .xrep2-popup .ant-picker-header-view button:hover {
  color:#e2e8f0;
}
.xflow-external-dark .xrep2-popup .ant-picker-content th {
  color:#94a3b8;
}
.xflow-external-dark .xrep2-popup .ant-picker-cell {
  color:#475569;
}
.xflow-external-dark .xrep2-popup .ant-picker-cell-in-view {
  color:#e2e8f0;
}
.xflow-external-dark .xrep2-popup .ant-picker-cell:hover .ant-picker-cell-inner {
  background:#1e293b;
}
.xflow-external-dark .xrep2-popup .ant-picker-cell-selected .ant-picker-cell-inner {
  background:#1890ff; color:#fff;
}
.xflow-external-dark .xrep2-popup .ant-picker-cell-today .ant-picker-cell-inner::before {
  border-color:#1890ff;
}
.xflow-external-dark .xrep2-popup .ant-picker-footer {
  border-color:#334155;
}
.xflow-external-dark .xrep2-popup .ant-picker-today-btn {
  color:#60a5fa;
}
.xflow-external-dark .xrep2-popup .ant-picker-decade-panel .ant-picker-cell,
.xflow-external-dark .xrep2-popup .ant-picker-year-panel .ant-picker-cell,
.xflow-external-dark .xrep2-popup .ant-picker-month-panel .ant-picker-cell {
  color:#475569;
}

/* ---- Dark mode: drawer (rendered via portal, outside .xrep2) ---- */
.xflow-external-dark .xrep2-drawer .ant-drawer-content,
.xflow-external-dark .xrep2-drawer .ant-drawer-header {
  background:#111827; border-color:#334155;
}
.xflow-external-dark .xrep2-drawer .ant-drawer-title,
.xflow-external-dark .xrep2-drawer .ant-drawer-close {
  color:#e2e8f0;
}
.xflow-external-dark .xrep2-drawer .ant-checkbox-wrapper {
  color:#e2e8f0;
}

/* ---- Dark mode: paginación ---- */
.xflow-external-dark .xrep2 .ant-pagination-item {
  background:#182235; border-color:#334155;
}
.xflow-external-dark .xrep2 .ant-pagination-item a {
  color:#94a3b8;
}
.xflow-external-dark .xrep2 .ant-pagination-item:hover {
  border-color:#1890ff;
}
.xflow-external-dark .xrep2 .ant-pagination-item:hover a {
  color:#1890ff;
}
.xflow-external-dark .xrep2 .ant-pagination-item-active {
  background:#0c2a3d; border-color:#1890ff;
}
.xflow-external-dark .xrep2 .ant-pagination-item-active a {
  color:#7dd3fc;
}
.xflow-external-dark .xrep2 .ant-pagination-prev .ant-pagination-item-link,
.xflow-external-dark .xrep2 .ant-pagination-next .ant-pagination-item-link {
  background:#182235; border-color:#334155; color:#94a3b8;
}
.xflow-external-dark .xrep2 .ant-pagination-prev:hover .ant-pagination-item-link,
.xflow-external-dark .xrep2 .ant-pagination-next:hover .ant-pagination-item-link {
  border-color:#1890ff; color:#1890ff;
}
.xflow-external-dark .xrep2 .ant-pagination-disabled .ant-pagination-item-link,
.xflow-external-dark .xrep2 .ant-pagination-disabled:hover .ant-pagination-item-link {
  background:#141a26; border-color:#2c3242; color:#4b5568;
}
.xflow-external-dark .xrep2 .ant-pagination-jump-prev .ant-pagination-item-link-icon,
.xflow-external-dark .xrep2 .ant-pagination-jump-next .ant-pagination-item-link-icon {
  color:#1890ff;
}
.xflow-external-dark .xrep2 .ant-pagination-jump-prev .ant-pagination-item-ellipsis,
.xflow-external-dark .xrep2 .ant-pagination-jump-next .ant-pagination-item-ellipsis {
  color:#4b5568;
}
.xflow-external-dark .xrep2 .ant-pagination-total-text,
.xflow-external-dark .xrep2 .ant-pagination-options-quick-jumper {
  color:#94a3b8;
}
.xflow-external-dark .xrep2 .ant-pagination-options-quick-jumper input {
  background:#0f172a; border-color:#334155; color:#f8fafc;
}
/* dropdown del "20 / page" es un portal, no queda dentro de .xrep2 */
.xflow-external-dark .ant-select-dropdown .ant-select-item {
  color:#e2e8f0;
}
.xflow-external-dark .ant-select-dropdown.ant-select-dropdown-placement-topLeft,
.xflow-external-dark .ant-select-dropdown.ant-select-dropdown-placement-bottomLeft {
  background:#182235; box-shadow:0 4px 18px rgba(0,0,0,.45);
}
.xflow-external-dark .ant-select-dropdown .ant-select-item-option-active:not(.ant-select-item-option-disabled) {
  background:#1e293b;
}
.xflow-external-dark .ant-select-dropdown .ant-select-item-option-selected:not(.ant-select-item-option-disabled) {
  background:#0c2a3d; color:#7dd3fc;
}

/* ---- Dark mode: Tag de estado (los colores preset de antd son pasteles
   claros pensados para fondo blanco; en oscuro quedan casi invisibles) ---- */
.xflow-external-dark .xrep2 .ant-tag {
  color:#e2e8f0;
}
.xflow-external-dark .xrep2 .ant-tag-default { background:#1f2937; border-color:#475569; color:#cbd5e1; }
.xflow-external-dark .xrep2 .ant-tag-blue { background:#0c2a3d; border-color:#1890ff; color:#7dd3fc; }
.xflow-external-dark .xrep2 .ant-tag-geekblue { background:#161b3d; border-color:#5470ff; color:#adc6ff; }
.xflow-external-dark .xrep2 .ant-tag-cyan { background:#083b3b; border-color:#13c2c2; color:#87e8e8; }
.xflow-external-dark .xrep2 .ant-tag-green { background:#0f2e17; border-color:#52c41a; color:#b7eb8f; }
.xflow-external-dark .xrep2 .ant-tag-gold { background:#3a2e08; border-color:#faad14; color:#ffe58f; }
.xflow-external-dark .xrep2 .ant-tag-orange { background:#3a2408; border-color:#fa8c16; color:#ffd591; }
.xflow-external-dark .xrep2 .ant-tag-volcano { background:#3a1a08; border-color:#fa541c; color:#ffbb96; }
.xflow-external-dark .xrep2 .ant-tag-red { background:#3a0d0d; border-color:#f5222d; color:#ffa39e; }
.xflow-external-dark .xrep2 .ant-tag-purple { background:#22103d; border-color:#722ed1; color:#d3adf7; }
`;

// Orden y set de columnas confirmado por negocio (documento "campos export
// orders", version final) para cada pestaña — son distintos entre sí (ej.
// TIENDAPICKUP/STORENAME y DESCUENTO van en posiciones distintas), por eso se
// arman con dos listas explícitas de "value" en vez de derivar una de la
// otra filtrando por nombre de campo. Los campos que no estan en el excel
// final fueron eliminados (confirmado con negocio) — ya no se preservan.
const ORDER_TAB_ORDER = [
  "ORDERID", "DATE_ADDED", "STORENAME", "TIENDAPICKUP",
  "SUBTOTAL_ORDER", "SHIPPINGCOST", "DISCOUNT", "TOTAL_ORDER", "INITIAL_TOTAL_ORDER",
  "STATUSNAME", "DATE_MODIFIED", "PAYMENT_CITY", "PAYMENTMETHOD",
  "HAVECOUPON", "COUPONCODE", "COUPONADMINCODE", "COUPONVALUE", "NOTA_SAP", "OBSERVACION",
  "FIRSTNAME", "LASTNAME", "EMAIL", "PHONE", "CUSTOMERID", "BIRTHDAY",
  "EVENTNAME", "EVENTTYPE",
  "SHIPPINGADDRESS", "ADDITIONALSHIPPINGINSTRUCTIONS", "ZONECODE", "SHIPPING_CITY", "SHIPPINGMETHOD", "SHIPPINGTYPE",
  "POSICION_RACK", "NIT", "RAZON_SOCIAL", "NROFACTURA", "INVOICE_STATUS", "INVOICE_DATE", "TRX",
  "NOTA_SAP_PREVENTA",
];

const SKU_TAB_ORDER = [
  "ORDERID", "DATE_ADDED", "STORENAME", "TIENDAPICKUP",
  "SKU", "SKU_NAME", "SKU_CATEGORYNAME", "SKU_KEYVARIANT", "SKU_SIZE", "SKU_REGULAR_PRICE",
  "DISCOUNT", "SKU_PRICE", "SKU_QUANTITY", "SKU_TOTAL", "SHIPPINGCOST", "TOTAL_ORDER",
  "STATUSNAME", "DATE_MODIFIED", "SHIPPING_CITY", "SHIPPINGMETHOD",
  "HAVECOUPON", "COUPONCODE", "COUPONADMINCODE", "COUPONVALUE", "NOTA_SAP",
  "EVENTNAME", "EVENTTYPE",
  "NIT", "RAZON_SOCIAL", "NROFACTURA", "INVOICE_STATUS", "INVOICE_DATE", "TRX",
  "NOTA_SAP_PREVENTA",
];

class page extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: true,
      drawerFields: false,
      pageSize: 20,
      api_url: "",
      api_urlV2: "",
      date_label: date_label,
      exportOrders: [],
      exportSkus: [],
      exportOrderCols: [],
      exportSkuCols: [],
      updateStatus: "OK",
      stores: [],
      storesCatalog: [],
      isChecked: true,
      summary: null,
      activeTab: "orders",
      showAllFilters: false,
      /*table filter*/
      filterConfig: {
        ORDERID: {
          label: "Nro Pedido Desde",
          type: "NUMBER",
          value:
            process.env.REACT_APP_DEV === "YES"
              ? "0"
              : "",
        },
        ORDERID_TO: {
          label: "Nro Pedido Hasta",
          type: "NUMBER",
          value:
            process.env.REACT_APP_DEV === "YES"
              ? "1000"
              : "",
        },
        CUSTOMER_NAME: { label: "Nombre Cliente", type: "TEXT", value: "" },
        FROMDATE: { label: "Desde", type: "DATE", value: fromDate },
        TODATE: { label: "Hasta", type: "DATE", value: new Date() },
        CITY: {
          label: "Ciudad",
          type: "SELECT",
          values: [{ text: "TODAS", value: "" }],
          value: "",
        },
        STOREID: {
          label: "Tienda",
          type: "MULTIPLE",
          values: [{ text: "TODAS", value: "" }],
          value: "",
        },
        STATUSID: {
          label: "Estado",
          type: "MULTIPLE",
          values: [{ text: "TODOS", value: "" }],
          value: "",
        },
        PAYMENTTYPEID: {
          label: "Tipo Pago",
          type: "MULTIPLE",
          values: [{ text: "TODOS", value: "" }],
          value: "",
        },
        SHIPPINGTYPEID: {
          label: "Typo Envío",
          type: "MULTIPLE",
          values: [{ text: "TODOS", value: "" }],
          value: "",
        },

        MIN_PRICE: { label: "Monto Max", type: "NUMBER", value: "0" },
        MAX_PRICE: { label: "Monto Min", type: "NUMBER", value: "999999" },
        HAVE_COUPON: {
          label: "Tiene Convenio",
          type: "SELECT",
          value: "",
          values: [
            { text: "TODOS", value: "" },
            { text: "SI", value: "YES" },
            { text: "NO", value: "NO" },
          ],
        },
        COUPONNAME: {
          label: "Nombre del Cupón",
          type: "SELECT",
          value: "",
          values: [{ text: "TODOS", value: "" }],
        },
      },
      showMore: true,
      /*table data*/
      tableData: {
        columns: [],
        rows: [],
      },

      tableData2: {
        columns: [],
        rows: [],
      },

      // Lista canónica de campos disponibles (fuente del drawer de
      // habilitar/deshabilitar columnas). El orden real de cada pestaña se
      // arma desde ORDER_TAB_ORDER / SKU_TAB_ORDER (arriba del archivo);
      // acá solo se busca `enabled`/`width` por `value`.
      defCols: [
        { value: "ORDERID", enabled: true, title: "Pedido", width: 150 },
        { value: "DATE_ADDED", enabled: true, title: "Fecha de Pedido", width: 150 },
        { value: "STORENAME", enabled: true, title: "Tienda", width: 150 },
        { value: "TIENDAPICKUP", enabled: true, title: "Tienda Pickup", width: 160 },
        { value: "SUBTOTAL_ORDER", enabled: true, title: "Subtotal", width: 150 },
        { value: "SHIPPINGCOST", enabled: true, title: "Costo de Envío", width: 150 },
        { value: "DISCOUNT", enabled: true, title: "Descuento", width: 150 },
        { value: "TOTAL_ORDER", enabled: true, title: "Total", width: 150 },
        { value: "INITIAL_TOTAL_ORDER", enabled: true, title: "Total Cobrado Online", width: 170 },
        { value: "STATUSNAME", enabled: true, title: "Estado", width: 150 },
        { value: "DATE_MODIFIED", enabled: true, title: "Fecha de Actualización", width: 150 },
        { value: "PAYMENT_CITY", enabled: true, title: "Ciudad", width: 150 },
        { value: "PAYMENTMETHOD", enabled: true, title: "Método de Pago", width: 150 },
        { value: "HAVECOUPON", enabled: true, title: "Nombre Cupón", width: 150 },
        { value: "COUPONCODE", enabled: true, title: "Código Cupón", width: 150 },
        { value: "COUPONADMINCODE", enabled: true, title: "Código Interno", width: 150 },
        { value: "COUPONVALUE", enabled: true, title: "Valor Cupón", width: 150 },
        { value: "NOTA_SAP", enabled: true, title: "Nota sap", width: 150 },
        { value: "OBSERVACION", enabled: true, title: "Observación", width: 200 },
        { value: "FIRSTNAME", enabled: true, title: "Nombre(s)", width: 150 },
        { value: "LASTNAME", enabled: true, title: "Apellido(s)", width: 150 },
        { value: "EMAIL", enabled: true, title: "Email", width: 200 },
        { value: "PHONE", enabled: true, title: "Teléfono", width: 150 },
        { value: "CUSTOMERID", enabled: true, title: "Id Cliente", width: 150 },
        { value: "BIRTHDAY", enabled: true, title: "Fecha de Nacimiento", width: 150 },
        { value: "EVENTNAME", enabled: true, title: "Nombre Evento", width: 200 },
        { value: "EVENTTYPE", enabled: true, title: "Tipo Evento", width: 150 },
        { value: "SHIPPINGADDRESS", enabled: true, title: "Dirección de Envío", width: 200 },
        { value: "ADDITIONALSHIPPINGINSTRUCTIONS", enabled: true, title: "Instrucciones de Envío", width: 250 },
        { value: "ZONECODE", enabled: true, title: "Código de Zona", width: 150 },
        { value: "SHIPPING_CITY", enabled: true, title: "Ciudad de Envío", width: 150 },
        { value: "SHIPPINGMETHOD", enabled: true, title: "Método de Envío", width: 150 },
        { value: "SHIPPINGTYPE", enabled: true, title: "Tipo de Envío", width: 150 },
        { value: "POSICION_RACK", enabled: true, title: "Posición Rack", width: 150 },
        { value: "NIT", enabled: true, title: "NIT", width: 150 },
        { value: "RAZON_SOCIAL", enabled: true, title: "Razón Social", width: 200 },
        { value: "NROFACTURA", enabled: true, title: "Número Factura", width: 150 },
        { value: "INVOICE_STATUS", enabled: true, title: "Estado Factura", width: 150 },
        { value: "INVOICE_DATE", enabled: true, title: "Fecha Factura", width: 150 },
        { value: "TRX", enabled: true, title: "TRX", width: 150 },

        // -- Detalle de SKU (solo aplican a la pestaña Pedidos SKUs, ver SKU_TAB_ORDER) --
        { value: "SKU", enabled: true, title: "SKU", width: 100 },
        { value: "SKU_NAME", enabled: true, title: "Nombre Específico", width: 200 },
        { value: "SKU_CATEGORYNAME", enabled: true, title: "Categoría Madre", width: 200 },
        { value: "SKU_KEYVARIANT", enabled: true, title: "Key Variante", width: 150 },
        { value: "SKU_SIZE", enabled: true, title: "Talla", width: 100 },
        { value: "SKU_REGULAR_PRICE", enabled: true, title: "Precio Regular", width: 150 },
        { value: "SKU_PRICE", enabled: true, title: "Precio", width: 150 },
        { value: "SKU_QUANTITY", enabled: true, title: "Cantidad", width: 100 },
        { value: "SKU_TOTAL", enabled: true, title: "Total SKU", width: 150 },
        { value: "NOTA_SAP_PREVENTA", enabled: true, title: "Nota SAP preventa", width: 150 },
      ],
      events: [],
      tipos_evento: []
    };
  }
  /*loading data*/
  componentDidMount = async () => {
    require("antd/dist/antd.css");
    console.log("init 2.1.0 (single source / redesign)");
    applyExternalDarkMode(this.props.location.search);

    await axios({
      url: `${process.env.REACT_APP_APIEVEN_CONFIG}/api/frontend/event/search?eventname=`,
      data: {},
      headers: {
        "Content-Type": "application/json"
      },
      method: "get",
    })
      .then((response) => response.data)
      .then((data) => {
        let events = data.rows;
        this.setState({ events });
      });

    try {

      var api_url = API_CONFIG.casaideas;
      var api_urlV2 = API_CONFIG.casaideasInt;

      const storesCatalog = await getCasaIdeasStores();
      this.setState({
        api_url: api_url,
        api_urlV2: api_urlV2,
        stores: buildStoreOptions(storesCatalog),
        storesCatalog: storesCatalog,
      });


      const apikey = API_CONFIG.casaideasIntToken;

      const requests = [
        callexternalApi(api_urlV2, "/api/frontend/getDomain", "post", { domainName: "metodos_pago" }),
        callexternalApi(api_urlV2, "/api/frontend/getDomain", "post", { domainName: "metodos_envio" }),
        callexternalApi(api_urlV2, "/api/frontend/getDomain", "post", { domainName: "tiendas" }),
        callexternalApi(api_urlV2, "/api/frontend/getDomain", "post", { domainName: "estados_orden" }),
        callexternalApi(api_urlV2, "/api/frontend/getDomain", "post", { domainName: "POLYGONS" }),
        callexternalApi(api_urlV2, "/api/getCoupons", "post", { apikey }),
        callexternalApi(api_urlV2, "/api/frontend/getDomain", "post", {
          domainName: "dominios",
          custom: {
            name: "dominio",
            value: "tipo_evento"
          }
        })
      ];

      const [
        resp1,
        resp2,
        resp3,
        resp4,
        resp5,
        resp6,
        resp7
      ] = await Promise.all(requests);

      this.setState({ tipos_evento: resp7.response });

      const filterConfig = this.state.filterConfig;

      resp1.rows.forEach(item => {
        filterConfig.PAYMENTTYPEID.values.push({
          text: item.metodo_pago,
          value: item.value
        });
      });

      resp2.rows.forEach(item => {
        filterConfig.SHIPPINGTYPEID.values.push({
          text: item.metodo_envio,
          value: item.value
        });
      });

      resp3.rows.forEach(item => {
        filterConfig.STOREID.values.push({
          text: item.tienda,
          value: item.value
        });
      });

      resp4.rows.forEach(item => {
        filterConfig.STATUSID.values.push({
          text: item.estado,
          value: item.value
        });
      });

      const cities = [...new Set(resp5.rows.map(item => item.region))];

      cities.forEach(city => {
        filterConfig.CITY.values.push({
          text: city,
          value: city
        });
      });

      resp6.rows.forEach(item => {
        filterConfig.COUPONNAME.values.push({
          text: item.couponname,
          value: item.id
        });
      });


    } catch (err) {
      console.log(">>>>>>>>>>", err);
    } finally {
      this.setState({ isLoading: false });
    }
  };

  // Despacha un cambio de filtro con el mismo contrato de eventos del searchHandler genérico
  setFilterValue = (name, value) => {
    this.searchHandler({ target: { name, value } });
  };

  // Nombre de la tienda pickup a partir del código de almacén (STOREPICKUP)
  getPickupStoreName = (row) => {
    const code = normalizeOfficeCode(row.STOREPICKUP);
    const name = getStoreNameByOfficeCode(code, this.state.storesCatalog);
    return name || row.STOREPICKUP || "";
  };

  // Nombre de la tienda madre (ciudad) de la tienda pickup
  getPickupParentStoreName = (row) => {
    const code = normalizeOfficeCode(row.STOREPICKUP);
    const parentCode = getParentOfficeCode(code, this.state.storesCatalog);
    return getStoreNameByOfficeCode(parentCode, this.state.storesCatalog) || "";
  };

  ///Search Manager
  searchHandler = async (event) => {
    this.setState({ isLoading: true });

    let apikey = API_CONFIG.casaideasIntToken;

    const searchStartTime = performance.now();

    let searchConfig = this.state.filterConfig;
    // findObjName sube por el DOM: el click puede caer en el icono/texto interno del boton.
    if (findObjName(event) === "search") {
      // Copia para no alterar lo que muestra el selector de fecha.
      searchConfig = {
        ...searchConfig,
        FROMDATE: { ...searchConfig.FROMDATE, value: boliviaDayStart(searchConfig.FROMDATE.value) },
        TODATE: { ...searchConfig.TODATE, value: boliviaDayEnd(searchConfig.TODATE.value) },
      };
    }

    let resp = await searchHandler(
      event,
      searchConfig,
      this.state.showMore,
      API_CONFIG.api_s3 + "/api/S3/report/orders",
      null,
      apikey
    );

    if (resp.filterConfig) {
      this.setState({
        filterConfig: resp.filterConfig,
      });
    }

    var summary = this.state.summary;
    var exportOrderCols = this.state.exportOrderCols;
    var exportSkuCols = this.state.exportSkuCols;
    var exportOrders = this.state.exportOrders;
    var exportSkus = this.state.exportSkus;
    var newExportOrderCols, newExportSkuCols;

    if (resp.tableData) {

      let ordersR = [];
      if (resp.tableData.orders) {
        for (var r in resp.tableData.orders) {
          var row = resp.tableData.orders[r];

          /* --- Enriquecimiento de eventos ---
             EVENTTYPE ahora viene directo del backend (o.tipo_evento, calculado al
             crear el pedido). El cruce por evento/domain solo se usa de fallback
             para pedidos viejos que aun no tienen el campo poblado en BD. */
          row["EVENTTYPE"] = row["EVENTTYPE"] || "";
          let posE = find(this.state.events, row.EVENTCODE, "eventcode");
          if (posE >= 0) {

            if (!row.EVENTNAME || row.EVENTNAME === "") {
              // aplicado para los pedidos antiguos
              row.EVENTNAME = this.state.events[posE].eventname;
            }

            if (!row["EVENTTYPE"]) {
              let posTE = find(this.state.tipos_evento, this.state.events[posE].eventtypeid, "SK");
              if (posTE >= 0) {
                row["EVENTTYPE"] = this.state.tipos_evento[posTE].text;
              }
            }
          }

          /* --- Cupones --- */
          if (row["CUPON_ID"] && row["HAVECOUPON"] !== "NO") {
            let coupons = row["HAVECOUPON"].split(",");
            let _couponnames = [];
            coupons.map(function (item) {
              if (_couponnames.indexOf(item) < 0) {
                _couponnames.push(item);
              }
            });
            let posC = find(this.state.filterConfig.COUPONNAME.values, row.CUPON_ID, "value");
            if (posC < 0) {
              let cuponName = row["ADMINCOUPONCODE"].split("___") ?? [];
              row["HAVECOUPON"] = cuponName[0] ?? "";
            } else {
              row["HAVECOUPON"] = this.state.filterConfig.COUPONNAME.values[posC].text;
            }
            row["COUPONCODE"] = _couponnames.toString();
            let couponsI = row["ADMINCOUPONCODE"].split("___");
            row["COUPONADMINCODE"] = couponsI[0];
            row.COUPONVALUE = couponsI[2] + (couponsI[1] === "PERCENTAGE" ? "%" : "Bs.");
          }

          this.state.defCols.map(function (item) {
            if (!item.enabled) {
              delete row[item.value];
            }
          });

          /* --- Lógica pickup (fuente única) ---
             - La separación por tienda sale de SKUS[].pickup_qty (orden_items.cantidad_pickup).
             - El estado del traspaso sale de ordenes.estado_pickup.
          */
          row["SKUS"] = parseSkusField(row.SKUS);

          const totalQty = row["SKUS"].reduce((acc, s) => acc + Number(s.qty || 0), 0);
          const pickupQty = row["SKUS"].reduce((acc, s) => acc + Number(s.pickup_qty || 0), 0);
          const isFullPickup = totalQty > 0 && pickupQty >= totalQty;
          const estadoPickupRaw = String(row.ESTADO_PICKUP || "").trim().toLowerCase();

          let isPickUp =
            pickupQty > 0 &&
            estadoPickupRaw !== "" &&
            estadoPickupRaw !== "finalizado";

          if (row["STATUSID"] === 5) {
            isPickUp = false;
          }

          if (row["STATUSID"] === 19) {
            row["STATUSNAME"] = "Cancelado";
          }

          // "Tienda" (STORENAME) ya viene resuelta del backend por join con
          // tiendas.descripcion (o.tienda_id) — no se sobreescribe con AGENCIA.
          row["REALSTORE"] = row.STORENAME || row.AGENCIA;

          if (isPickUp) {
            let rowT = { ...row };
            // "Tienda Pickup" también viene del backend por join (tienda_pickup_id
            // -> tiendas.descripcion); getPickupStoreName (catálogo) queda solo
            // como respaldo si el pedido no tiene tienda_pickup_id.
            const pickupStoreName = row.TIENDAPICKUP || this.getPickupStoreName(row);
            const parentStoreName = this.getPickupParentStoreName(row);
            let estado_pickup = mapPickupState(estadoPickupRaw);

            if (row.STATUSNAME === "Cancelado") {
              estado_pickup = "Cancelado";
            }

            if (isFullPickup) {
              // Pedido 100% pickup: una sola fila con el estado del traspaso
              if (row["STATUSID"] !== 6 && row["STATUSID"] !== 5) {
                row["STATUSNAME"] = estado_pickup;
              }

              row["TIENDAPICKUP"] = pickupStoreName;

              ordersR.push(row);
            } else {
              // Pedido parcial: fila normal + fila "-p" con el traspaso en la tienda madre
              if (row["STATUSID"] === 10) {
                row["STATUSNAME"] = row["STATUSNAME"] + "(parcialmente)";
              }

              row["TIENDAPICKUP"] = pickupStoreName;

              ordersR.push(row);

              rowT["STATUSNAME"] = estado_pickup;
              rowT["ORDERID"] = row["ORDERID"] + "-p";
              //rowT["TIENDAPICKUP"] = parentStoreName || pickupStoreName;
              //Cambiamos el orden para que se visualice la verdadera tienda donde se recoge  el pedido
               rowT["TIENDAPICKUP"] =  ( pickupStoreName || parentStoreName   );

              ordersR.push(rowT);
            }
          } else {
            // Delivery o evento (no pickup): TIENDAPICKUP viene vacío del backend,
            // se replica la Tienda/Tienda Stock para no dejar la columna en blanco.
            row["TIENDAPICKUP"] = row["TIENDAPICKUP"] || row["STORENAME"] || "";
            ordersR.push(row);
          }

        }
      }

      const tableData = this.state.tableData;
      tableData.rows = ordersR;

      let ordersSKUs = [];
      if (resp.tableData.ordersskus) {
        for (var r2 in resp.tableData.ordersskus) {
          let row = resp.tableData.ordersskus[r2];

          this.state.defCols.map(function (item) {
            if (!item.enabled) {
              delete row[item.value];
            }
          });

          let filteredItems = tableData.rows.filter(
            (item) => item.ORDERID === row.ORDERID
          );

          let matchingItem = filteredItems[0];

          if (matchingItem) {
            row["COUPONCODE"] = matchingItem.COUPONCODE || "";
            row["BIRTHDAY"] = matchingItem.BIRTHDAY || "";
            row["EVENTNAME"] = matchingItem.EVENTNAME || "";
            row["EVENTTYPE"] = matchingItem.EVENTTYPE || "";
            row["COUPONADMINCODE"] = matchingItem.COUPONADMINCODE || "";
            row["COUPONVALUE"] = matchingItem.COUPONVALUE || "";
            row["HAVECOUPON"] = matchingItem.HAVECOUPON || "";
            row["STATUSNAME"] = matchingItem.STATUSNAME;
            row["STORENAME"] = matchingItem.STORENAME || row["STORENAME"];
            row["TIENDAPICKUP"] = matchingItem.TIENDAPICKUP || "";

            // Tienda stock real por SKU: SKUS[].store_name ya viene resuelto del
            // backend (mismo JOIN contra `tiendas` que arma STORENAME/TIENDAPICKUP
            // del pedido), nombre completo, sin depender de ningún catálogo/lista
            // del frontend. Tienda Pickup queda uniforme (el destino de recojo del
            // pedido completo); Tienda Stock sí varía por SKU.
            if (matchingItem.SKUS && matchingItem.SKUS.length > 0) {
              let skuPos = matchingItem.SKUS.filter(
                (item) => item.sku === row.SKU
              );
              if (skuPos.length > 0 && skuPos[0].store_name) {
                row["STORENAME"] = skuPos[0].store_name;
              }
            }

            row["TRX"] = matchingItem.TRX;
            row["INVOICE_DATE"] = matchingItem.INVOICE_DATE;
            row["INVOICE_STATUS"] = matchingItem.INVOICE_STATUS;
            row["NROFACTURA"] = matchingItem.NROFACTURA;
            {
              // HU06: ordenes.nota_sap guarda "<nota stock>|<nota preventa>"; la segunda va en su propia columna al final
              const _notas = String(matchingItem.NOTA_SAP ?? "").split("|");
              row["NOTA_SAP"] = _notas[0] || "";
              row["NOTA_SAP_PREVENTA"] = _notas[1] || "";
            }
            row["POSICION_RACK"] = matchingItem.POSICION_RACK;

            row["DATE_MODIFIED"] = matchingItem.DATE_MODIFIED;
            row["DATE_ADDED"] = matchingItem.DATE_ADDED;

            // Delivery o evento (no pickup): TIENDAPICKUP viene vacío del backend,
            // se replica la Tienda/Tienda Stock para no dejar la columna en blanco.
            row["TIENDAPICKUP"] = row["TIENDAPICKUP"] || row["STORENAME"] || "";
          }

          ordersSKUs.push(...expandComboSkuRows(row));
        }
      }

      const tableData2 = this.state.tableData2;
      tableData2.rows = ordersSKUs;

      const defColsByValue = new Map(
        this.state.defCols.map((item) => [item.value, item])
      );

      var _columns = [];
      var _defCols = [];
      ORDER_TAB_ORDER.forEach((value) => {
        const item = defColsByValue.get(value);
        if (item && item.enabled) {
          _columns.push({
            dataIndex: item.value,
            title: item.title,
            width: item.width,
          });
          _defCols.push(item);
        }
      });
      tableData.columns = _columns;
      newExportOrderCols = _defCols;

      _defCols = [];
      _columns = [];
      SKU_TAB_ORDER.forEach((value) => {
        const item = defColsByValue.get(value);
        if (item && item.enabled) {
          const title = item.title === "Tienda" ? "Tienda Stock" : item.title;
          _columns.push({
            dataIndex: item.value,
            title,
            width: item.width,
          });
          _defCols.push({ ...item, title });
        }
      });
      tableData2.columns = _columns;
      newExportSkuCols = _defCols;

      /* --- Resumen ejecutivo --- */
      const realOrders = ordersR.filter(
        (item) => String(item.ORDERID).indexOf("-p") < 0
      );
      const totalUnits = ordersSKUs.reduce(
        (acc, item) => acc + Number(item.SKU_QUANTITY || 0),
        0
      );
      const totalAmount = realOrders.reduce(
        (acc, item) => acc + Number(item.TOTAL_ORDER || 0),
        0
      );
      summary = {
        orders: realOrders.length,
        units: totalUnits,
        total: totalAmount,
        avgTicket: realOrders.length ? totalAmount / realOrders.length : 0,
        pickup: realOrders.filter(
          (item) =>
            (item.SKUS || []).reduce(
              (acc, s) => acc + Number(s.pickup_qty || 0),
              0
            ) > 0
        ).length,
        elapsed: ((performance.now() - searchStartTime) / 1000).toFixed(1),
        fromDate: this.state.filterConfig.FROMDATE.value,
        toDate: this.state.filterConfig.TODATE.value,
      };

      exportOrders = ordersR;
      exportSkus = ordersSKUs;
      exportOrderCols = newExportOrderCols;
      exportSkuCols = newExportSkuCols;

      window.location.hash = "#results";
    }

    this.setState({
      isLoading: false,
      exportOrders: exportOrders,
      exportSkus: exportSkus,
      exportOrderCols: exportOrderCols,
      exportSkuCols: exportSkuCols,
      summary: summary,
    });
  };

  selectItem = (item) => {
    if (item != "ORDERID" && item != "SKU") {
      var defCols = this.state.defCols;
      defCols.map(function (row) {
        if (row.value == item) {
          row["enabled"] = !row["enabled"];
        }
      });
      this.setState({ defCols: defCols });
    }
  };

  selectAllItems = (item) => {
    var defCols = this.state.defCols;
    defCols.map(function (row) {
      if (row.value != "ORDERID" && row.value != "SKU") {
        row["enabled"] = true;
      }
    });
    this.setState({ defCols: defCols, isChecked: true });
  };

  removeAllItem = (item) => {
    var defCols = this.state.defCols;
    defCols.map(function (row) {
      if (row.value != "ORDERID" && row.value != "SKU") {
        row["enabled"] = false;
      }
    });
    this.setState({ defCols: defCols, isChecked: false });
  };

  /* ============ export a excel (exceljs, con formato real) ============ */

  exportToExcel = async () => {
    const { exportOrders, exportSkus, exportOrderCols, exportSkuCols, summary } = this.state;
    if (!exportOrders || !exportOrders.length) return;

    const fmtDate = (d) => (d ? moment(d).format("DD/MM/YYYY") : "-");
    const wb = new ExcelJS.Workbook();
    wb.creator = "Reporte de Pedidos";
    wb.created = new Date();

    addSummarySheet(wb, {
      title: "Reporte de Pedidos",
      generatedAt: moment().format("DD/MM/YYYY HH:mm"),
      period: `${fmtDate(summary?.fromDate)}  -  ${fmtDate(summary?.toDate)}`,
      kpis: [
        ["Pedidos", summary?.orders || 0],
        ["SKUs", summary?.units || 0],
        ["Ventas (Bs.)", Number((summary?.total || 0).toFixed(2))],
        ["Ticket Promedio (Bs.)", Number((summary?.avgTicket || 0).toFixed(2))],
        ["Pedidos con PickUp", summary?.pickup || 0],
      ],
    });

    addDataSheet(wb, {
      name: "Pedidos",
      rows: exportOrders,
      cols: exportOrderCols,
      moneyCols: MONEY_COLS,
      statusKey: "STATUSNAME",
    });

    addDataSheet(wb, {
      name: "Pedidos SKUs",
      rows: exportSkus,
      cols: exportSkuCols,
      moneyCols: MONEY_COLS,
      statusKey: "STATUSNAME",
    });

    await downloadWorkbook(wb, "export-orders." + this.state.date_label + ".xlsx");
  };

  /* ============ render helpers ============ */

  renderCellByColumn = (col) => {
    if (col === "ORDERID") {
      return (text) => {
        const isTransfer = String(text).indexOf("-p") >= 0;
        return (
          <span className="xrep2-orderid">
            {text}{" "}
            {isTransfer && (
              <Tooltip title="Fila de traspaso pickup">
                <Tag color="orange" style={{ marginLeft: 2 }}>
                  traspaso
                </Tag>
              </Tooltip>
            )}
          </span>
        );
      };
    }
    if (col === "STATUSNAME" || col === "INVOICE_STATUS") {
      return (text) =>
        text ? <Tag color={statusColor(text)}>{text}</Tag> : "";
    }
    if (MONEY_COLS.indexOf(col) >= 0) {
      return (text) => (
        <span
          className="xrep2-money"
          style={col === "TOTAL_ORDER" || col === "SKU_TOTAL" ? { fontWeight: 700 } : {}}
        >
          {formatMoney(text)}
        </span>
      );
    }
    if (col === "SKU" || col === "TRX" || col === "NROFACTURA" || col === "POSICION_RACK") {
      return (text) => <span className="xrep2-mono">{text}</span>;
    }
    if (col === "EMAIL") {
      return (text) => <span style={{ color: "#1890ff" }}>{text}</span>;
    }
    return undefined;
  };

  // Con tableLayout="fixed" el scroll.x debe ser la suma real de anchos
  // declarados (no "max-content"), si no header y body vuelven a desalinearse.
  tableScrollWidth = (columns) =>
    (columns || []).reduce((acc, c) => acc + (c.width || 140), 0);

  // width es obligatorio en TODAS las columnas: con scroll.y, antd separa header
  // y body en dos <table>; una columna sin width descuadra el cálculo y el
  // desfase se va acumulando de columna en columna.
  buildAntColumns = (columns) =>
    (columns || []).map((c) => {
      const column = {
        key: c.dataIndex,
        dataIndex: c.dataIndex,
        title: c.title,
        width: c.width || 140,
        ellipsis: true,
        render: this.renderCellByColumn(c.dataIndex),
      };
      if (MONEY_COLS.indexOf(c.dataIndex) >= 0 || c.dataIndex === "ORDERID") {
        column.sorter = (a, b) =>
          Number(String(a[c.dataIndex]).replace(/[^0-9.-]/g, "") || 0) -
          Number(String(b[c.dataIndex]).replace(/[^0-9.-]/g, "") || 0);
      }
      if (c.dataIndex === "STATUSNAME") {
        column.sorter = (a, b) =>
          String(a.STATUSNAME || "").localeCompare(String(b.STATUSNAME || ""));
      }
      return column;
    });

  renderFilterField = (field) => {
    const cfg = this.state.filterConfig[field];
    if (!cfg) return null;

    let control = null;

    if (cfg.type === "DATE") {
      control = (
        <DatePicker
          style={{ width: "100%" }}
          allowClear={false}
          value={cfg.value ? moment(cfg.value) : moment()}
          format="DD/MM/YYYY"
          dropdownClassName="xrep2-popup"
          onChange={(m) =>
            this.setFilterValue(field, m ? m.toDate() : new Date())
          }
        />
      );
    } else if (cfg.type === "SELECT") {
      control = (
        <Select
          style={{ width: "100%" }}
          value={cfg.value}
          onChange={(v) => this.setFilterValue(field, v)}
          showSearch
          optionFilterProp="children"
          dropdownClassName="xrep2-popup"
        >
          {cfg.values.map((item) => (
            <Option key={"opt_" + field + "_" + item.value} value={item.value}>
              {item.text}
            </Option>
          ))}
        </Select>
      );
    } else if (cfg.type === "MULTIPLE") {
      const currentValue = Array.isArray(cfg.value)
        ? cfg.value
        : cfg.value === "" || cfg.value === undefined
          ? []
          : [cfg.value];
      control = (
        <Select
          mode="multiple"
          allowClear
          maxTagCount={2}
          placeholder="Todos"
          style={{ width: "100%" }}
          value={currentValue}
          onChange={(vals) => {
            // mismo contrato que el <select multiple> nativo:
            // sin selección -> "", una selección -> string, varias -> array
            let value = (vals || []).map((v) =>
              isNaN(parseInt(v)) ? v : parseInt(v)
            );
            if (value.length === 0) value = "";
            else if (value.length === 1) value = value[0] + "";
            this.setFilterValue(field, value);
          }}
          optionFilterProp="children"
          dropdownClassName="xrep2-popup"
        >
          {cfg.values
            .filter((item) => item.value !== "")
            .map((item) => (
              <Option key={"opt_" + field + "_" + item.value} value={item.value}>
                {item.text}
              </Option>
            ))}
        </Select>
      );
    } else {
      control = (
        <Input
          value={cfg.value}
          onChange={(e) => this.setFilterValue(field, e.target.value)}
          allowClear
        />
      );
    }

    return (
      <div className="xrep2-field" key={"f_" + field}>
        <label>{cfg.label}</label>
        {control}
      </div>
    );
  };

  render() {
    const { summary, tableData, tableData2, activeTab, showAllFilters } =
      this.state;

    const primaryFilters = ["FROMDATE", "TODATE", "ORDERID", "ORDERID_TO", "CUSTOMER_NAME", "CITY"];
    const extraFilters = [
      "STOREID",
      "STATUSID",
      "PAYMENTTYPEID",
      "SHIPPINGTYPEID",
      "MIN_PRICE",
      "MAX_PRICE",
      "HAVE_COUPON",
      "COUPONNAME",
    ];

    const kpis = summary
      ? [
        { label: "Pedidos", value: summary.orders, icon: "fas fa-shopping-cart", color: "#1890ff" },
        { label: "Productos procesados", value: summary.units, icon: "fas fa-boxes", color: "#722ed1" },
        { label: "Ventas (Bs.)", value: formatMoney(summary.total), icon: "fas fa-coins", color: "#52c41a" },
        { label: "Ticket Promedio", value: formatMoney(summary.avgTicket), icon: "fas fa-receipt", color: "#fa8c16" },
        { label: "Con PickUp", value: summary.pickup, icon: "fas fa-store", color: "#13c2c2" },
      ]
      : [];

    const pagination = {
      pageSize: this.state.pageSize,
      showSizeChanger: true,
      pageSizeOptions: ["10", "20", "50", "100"],
      showTotal: (total, range) =>
        `${range[0]}-${range[1]} de ${total} registros`,
      onShowSizeChange: (current, size) => this.setState({ pageSize: size }),
      onChange: (page, size) => this.setState({ pageSize: size }),
    };

    return (
      <>
        <style>{PAGE_CSS}</style>
        <PageLoading isLoading={this.state.isLoading} />

        <Drawer
          title="Campos a exportar"
          placement="right"
          width={420}
          className="xrep2-drawer"
          visible={this.state.drawerFields}
          onClose={() => this.setState({ drawerFields: false })}
        >
          <div style={{ marginBottom: 12, display: "flex", gap: 8 }}>
            {this.state.isChecked ? (
              <Button size="small" onClick={this.removeAllItem}>
                Desmarcar todos
              </Button>
            ) : (
              <Button size="small" type="primary" onClick={this.selectAllItems}>
                Marcar todos
              </Button>
            )}
          </div>
          <div
            style={{
              display: "grid",
              gridTemplateColumns: "1fr 1fr",
              gap: "6px 10px",
            }}
          >
            {this.state.defCols.map((row) => (
              <Checkbox
                key={"chk_" + row.value}
                checked={row.enabled}
                disabled={row.value === "ORDERID" || row.value === "SKU"}
                onChange={() => this.selectItem(row.value)}
              >
                {row.title}
              </Checkbox>
            ))}
          </div>
        </Drawer>

        <div className="page-wrapper xext-page xext-exportorders-hist">
          <div className="content container-fluid xrep2">
            {/* ===== Header ===== */}
            <div className="xrep2-header">
              <div className="xrep2-title">
                <h2>
                  <i
                    className="fas fa-chart-line"
                    style={{ color: "#1890ff", marginRight: 10 }}
                  />
                  Reporte de Pedidos
                </h2>
                <small>
                  Histórico de ventas, traspasos pickup y facturación
                </small>
              </div>
              <div className="xrep2-actions">
                {summary && (
                  <span className="xrep2-elapsed">
                    <i className="far fa-clock" /> {summary.elapsed}s
                  </span>
                )}
                <Button
                  icon={<i className="fas fa-columns" style={{ marginRight: 6 }} />}
                  onClick={() => this.setState({ drawerFields: true })}
                >
                  Columnas
                </Button>
                <Button
                  type="primary"
                  disabled={tableData.rows.length === 0}
                  onClick={this.exportToExcel}
                  style={
                    tableData.rows.length
                      ? { background: "#52c41a", borderColor: "#52c41a" }
                      : {}
                  }
                  icon={
                    <i
                      className="fas fa-file-excel"
                      style={{ marginRight: 6 }}
                    />
                  }
                >
                  Exportar Excel
                </Button>
              </div>
            </div>

            {/* ===== Filtros ===== */}
            <div className="xrep2-panel">
              <div className="xrep2-filters-grid">
                {primaryFilters.map((field) => this.renderFilterField(field))}
                {showAllFilters &&
                  extraFilters.map((field) => this.renderFilterField(field))}
              </div>
              <div className="xrep2-filters-footer">
                <Button
                  type="link"
                  size="small"
                  onClick={() =>
                    this.setState({ showAllFilters: !showAllFilters })
                  }
                >
                  <i
                    className={
                      "fas fa-angle-" + (showAllFilters ? "up" : "down")
                    }
                    style={{ marginRight: 5 }}
                  />
                  {showAllFilters ? "Menos filtros" : "Más filtros"}
                </Button>
                <Button
                  type="primary"
                  size="large"
                  name="search"
                  onClick={this.searchHandler}
                  icon={
                    <i className="fas fa-search" style={{ marginRight: 8 }} />
                  }
                >
                  Generar Reporte
                </Button>
              </div>
            </div>

            {/* ===== KPIs ===== */}
            {summary && (
              <div className="xrep2-kpis" id="results">
                {kpis.map((kpi) => (
                  <div className="xrep2-kpi" key={kpi.label}>
                    <div
                      className="xrep2-kpi-icon"
                      style={{ background: kpi.color }}
                    >
                      <i className={kpi.icon} />
                    </div>
                    <div>
                      <p className="xrep2-kpi-label">{kpi.label}</p>
                      <p className="xrep2-kpi-value">{kpi.value}</p>
                    </div>
                  </div>
                ))}
              </div>
            )}

            {this.state.updateStatus !== "OK" && (
              <div
                className="xrep2-panel"
                style={{ background: "#fff7e6", borderColor: "#ffd591" }}
              >
                <b>
                  <i className="fas fa-exclamation-triangle" /> ADVERTENCIA:
                </b>{" "}
                {this.state.updateStatus}
              </div>
            )}

            {/* ===== Resultados ===== */}
            <div className="xrep2-tables">
              {tableData.rows.length === 0 ? (
                <Empty
                  style={{ padding: "40px 0" }}
                  description="Configura los filtros y presiona Generar Reporte"
                />
              ) : (
                <Tabs
                  activeKey={activeTab}
                  onChange={(key) => this.setState({ activeTab: key })}
                >
                  <TabPane
                    tab={
                      <span>
                        <i
                          className="fas fa-shopping-bag"
                          style={{ marginRight: 6 }}
                        />
                        Pedidos ({tableData.rows.length})
                      </span>
                    }
                    key="orders"
                  >
                    <AntTable
                      size="small"
                      tableLayout="fixed"
                      columns={this.buildAntColumns(tableData.columns)}
                      dataSource={tableData.rows}
                      rowKey={(record, index) => "o" + index}
                      pagination={pagination}
                      scroll={{ x: this.tableScrollWidth(tableData.columns) }}
                    />
                  </TabPane>
                  <TabPane
                    tab={
                      <span>
                        <i
                          className="fas fa-barcode"
                          style={{ marginRight: 6 }}
                        />
                        Detalle SKUs ({tableData2.rows.length})
                      </span>
                    }
                    key="skus"
                  >
                    <AntTable
                      size="small"
                      tableLayout="fixed"
                      columns={this.buildAntColumns(tableData2.columns)}
                      dataSource={tableData2.rows}
                      rowKey={(record, index) => "s" + index}
                      pagination={pagination}
                      scroll={{ x: this.tableScrollWidth(tableData2.columns) }}
                    />
                  </TabPane>
                </Tabs>
              )}
            </div>
          </div>
        </div>
      </>
    );
  }
}
export default page;